import { Base, useResize } from '@studiometa/js-toolkit';
import { toggleClass } from '@studiometa/js-toolkit/utils';

/**
 * Footer component
 */
export default class Footer extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Footer',
  };

  /**
   * get root el
   * @returns {HTMLElement}
   */
  get root() {
    return document.querySelector(':root');
  }

  /**
   * Mounted hook
   */
  mounted() {
    this.update();
  }

  /**
   * resized hook
   */
  resized() {
    this.update();
  }

  /**
   * Met à jour la hauteur du footer et son mode de positionnement.
   *
   * À partir du breakpoint `s`, le footer est en `position: fixed` et se dévoile
   * au scroll. Ce mode n'est tenable que s'il tient dans le viewport, sinon son
   * bas resterait inaccessible : on le repasse alors dans le flux via la classe
   * `is-footer-static`, qui pilote aussi la désactivation de son animation.
   */
  update() {
    const { height } = this.$el.getBoundingClientRect();
    const { activeBreakpoints, height: viewportHeight } = useResize().props();

    this.root.style.setProperty('--footer-height', `${height}px`);
    toggleClass(this.root, 'is-footer-static', activeBreakpoints.s && height > viewportHeight);
  }
}
